import { render } from "./delivery_schedule_history.vue?vue&type=template&id=71792527"
import script from "./delivery_schedule_history.vue?vue&type=script&lang=js"
export * from "./delivery_schedule_history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__